import $ from "jquery";
import TemplateView from "../TemplateView"

export default class TaskSelectionLabel extends TemplateView{
    constructor($containerEl, editable){
        super($containerEl);
        this.isSelected = false;
        this.isDisabled = !editable;
        this.ediatable = editable;
        this.$containerEl = $containerEl;
    }

    templateHtml(){
        return "<div class='checkbox'>" +
               "  <div class='img'></div>" +
               "</div>";
    }

    afterRender()
    {
        var self = this;
        self.$el = self.$containerEl.find(".checkbox");
        this.bindClick(function()
                       {
                           if (!self.isDisabled)
                           {
                               self.setSelection(!self.isSelected);
                               $(self).trigger("change", self.isSelected);
                           }
                       });
    }

    setSelection(isSelected)
    {
        if (isSelected !== this.isSelected)
        {
            this.isSelected = isSelected;
            this.update();
        }
    }

    setDisabled(isDisabled)
    {
        if (this.ediatable && isDisabled !== this.isDisabled)
        {
            this.isDisabled = isDisabled;
            this.update();
        }
    }

    setEditable(editable)
    {
        this.ediatable = editable;
        if (!editable)
            this.isDisabled = true;
    }

    update()
    {
        this.$el.toggleClass("disabled", this.isDisabled);
        this.$el.toggleClass("active", this.isSelected);
        this.$el.toggleClass("inactive", !this.isSelected);
    }
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/TaskSelectionLabel.js